import React from "react";
import { Link } from "react-router-dom";

// `variant`:
//   - "inline"  → small icon + wordmark side-by-side (navbar, dashboards)
//   - "full"    → full uploaded logo image (icon + Wapit + WhatsApp Business API tagline)
// `tone`:
//   - "dark"    → as-is (use on light backgrounds)
//   - "light"   → CSS filter to render in white (use on dark backgrounds)
//
// The logo always navigates to the homepage when clicked.
// Pass `as="span"` to opt out of the link (rare — e.g. inside another <a>).
export const Logo = ({ variant = "inline", tone = "dark", className = "", showWordmark = true, as = "link" }) => {
  const toneCls = tone === "light" ? "[filter:brightness(0)_invert(1)]" : "";

  let inner;
  if (variant === "full") {
    inner = (
      <img
        src="/brand/logo.png"
        alt="Wappit — Official WhatsApp Business API"
        className={`h-16 sm:h-20 w-auto select-none ${toneCls}`}
        draggable={false}
      />
    );
  } else {
    inner = (
      <>
        <img
          src="/brand/icon.png"
          alt="Wappit"
          className={`h-9 w-9 object-contain select-none ${toneCls}`}
          draggable={false}
        />
        {showWordmark && (
          <span
            className={`text-xl font-extrabold tracking-tight ${tone === "light" ? "text-white" : "text-slate-900"}`}
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Wappit
          </span>
        )}
      </>
    );
  }

  const wrapperClass = variant === "full"
    ? `inline-flex ${className}`
    : `flex items-center gap-2 ${className}`;

  if (as === "span") {
    return <div className={wrapperClass} data-testid="brand-logo">{inner}</div>;
  }

  return (
    <Link
      to="/"
      data-testid="brand-logo"
      aria-label="Wappit — go to homepage"
      className={`${wrapperClass} hover:opacity-90 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 rounded-md`}
    >
      {inner}
    </Link>
  );
};
